import { Box, Stack } from '@mui/material'
import { DashboardBarChart } from './DashboardBarChart'
import { SectionCard } from './SectionCard'
import { StatTile } from './StatTile'
import { type GoalView } from './goalViews'

// The beside-the-chart layout needs the taller chart to line up with its two stacked tiles.
const CHART_HEIGHT = { tilesBesideChart: 358, tilesAboveChart: 300 }

export const GoalPanel = ({ layout, tiles, chart }: Pick<GoalView, 'layout' | 'tiles' | 'chart'>): JSX.Element => {
  const chartCard = chart != null && chart.data.length > 0
    ? (
      <SectionCard title={chart.title} testId='p2pDashboardChart'>
        <DashboardBarChart data={chart.data} formatKey={chart.formatKey} height={CHART_HEIGHT[layout]} />
      </SectionCard>
      )
    : null

  if (layout === 'tilesBesideChart') {
    return (
      <Stack direction={{ xs: 'column', md: 'row' }} gap='24px' alignItems='flex-start'>
        <Stack gap='24px' sx={{ width: { xs: '100%', md: '320px' }, flexShrink: 0 }}>
          {tiles.map(tile => <StatTile key={tile.label} {...tile} />)}
        </Stack>
        {chartCard != null && <Box sx={{ flexGrow: 1, flexBasis: 0, minWidth: 0, width: 0 }}>{chartCard}</Box>}
      </Stack>
    )
  }

  return (
    <>
      <Stack direction='row' gap='16px' flexWrap='wrap' alignItems='stretch'>
        {tiles.map(tile => <StatTile key={tile.label} grow {...tile} />)}
      </Stack>
      {chartCard}
    </>
  )
}
